<div class="container my-3">
  <!-- <h1 class="mb-3">Add User</h1> -->
  <form #form="ngForm" (ngSubmit)="addUser()" class="mt-4">
    <!-- [(ngModel)]="addUserRequest.RoleId"== role.Name -->
    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="roleId" class="form-label">Company</label>
      </div>
      <div class="col-sm-4">
        <select class="form-select border border-dark" [(ngModel)]="CompanyId" name="CompanyId"
          id="CompanyId">
          <option value="0" selected="true" disabled>Choose Company</option>
          <option *ngFor="let company of companys" value="{{ company.Id }}"
            [selected]="company.Id === addUserRequest.CompanyId">
            {{ company.Name }}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="roleId" class="form-label">Account Type</label>
      </div>

      <!-- <select class="form-select border border-dark" [(ngModel)]="addUserRequest.RoleId" name="roleId">
            <option *ngFor="let role of roles" value="{{role.Id}}" selected>{{ role.Name
              }}
            </option>
          </select> -->
      <div class="col-sm-4">
        <select class="form-select border border-dark" style="float: left" [(ngModel)]="addUserRequest.RoleId"
          name="roleId" (change)="updateRoleName($event)">
          <option value="" selected="true" disabled>Select Account Type</option>
          <option *ngFor="let role of roles" [value]="role.Id" selected>
            {{ role.Name }}
          </option>
        </select>
      </div>
    </div>
  </form>

  <form #form="ngForm" [formGroup]="AddUserForm" (ngSubmit)="addUser()">
    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="firstName" class="form-label">First Name</label>
      </div>
      <div class="col-sm-4">
        <input type="string" class="form-control border border-dark" id="firstName" name="firstName"
          formControlName="FirstName" [ngClass]="{
            'is-invalid': submitted && AddUserForm.controls.FirstName.errors
          }" (change)="validateFirstName()" required />
        <div *ngIf="submitted && AddUserForm.controls.FirstName.errors" class="text-danger" style="text-align: left">
          First Name is required
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="lastName" class="form-label">Last Name</label>
      </div>
      <div class="col-sm-4">
        <input type="string" class="form-control border border-dark" id="lastName" name="lastName"
          formControlName="LastName" [ngClass]="{
            'is-invalid': submitted && AddUserForm.controls.LastName.errors
          }" (change)="validateLastName()" required />
        <div *ngIf="submitted && AddUserForm.controls.LastName.errors" class="text-danger" style="text-align: left">
          Last Name is required
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="email" class="form-label">Email</label>
      </div>
      <div class="col-sm-4">
        <input type="email" class="form-control border border-dark" id="email" name="email" formControlName="UserEmail"
          [ngClass]="{
            'is-invalid': submitted && AddUserForm.controls.UserEmail.errors
          }" (change)="validateEmail()" required />
        <div *ngIf="submitted && AddUserForm.controls.UserEmail.errors" class="text-danger" style="text-align: left">
          <span *ngIf="AddUserForm.controls.UserEmail.errors.required">Email is required.</span>
          <span *ngIf="AddUserForm.controls.UserEmail.errors.email">Invalid email format.</span>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="username" class="form-label">UserName</label>
      </div>
      <div class="col-sm-4">
        <input type="email" class="form-control border border-dark" id="username" name="username"
          formControlName="Username" [ngClass]="{
            'is-invalid': submitted && AddUserForm.controls.Username.errors
          }" (change)="validateUsername()" required />
        <div *ngIf="submitted && AddUserForm.controls.Username.errors" class="text-danger" style="text-align: left">
          <span *ngIf="AddUserForm.controls.Username.errors.required">Username is required.</span>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="password" class="form-label">Password</label>
      </div>
      <div class="col-sm-4">
        <input type="string" class="form-control border border-dark" id="password" name="password"
          formControlName="Password" [ngClass]="{
            'is-invalid': submitted && AddUserForm.controls.Password.errors
          }" (input)="validatePassword($event)" required autocomplete="off" />

        <div style="color: red; text-align: left;" *ngIf="containsUsername">
          Username cannot be part of the password.
        </div>
        <div style="color: red; text-align: left;" *ngIf="isCommonPassword">
          Common passwords like "password" are not allowed.
        </div>
        <div style="color: red; text-align: left;" *ngIf="containsConsecutiveNumbers">
          Password should not contain consecutive numbers.
        </div>
        <div style="color: red; text-align: left;" *ngIf="containsRepeatingChars">
          Password should not contain repeating characters.
        </div>

        <div class="m-2">
          <div class="row">
            <div class="col-10" style="text-align: left">
              <label style="font-weight: bolder;">Password Must Contain</label>
            </div>
          </div>

          <div class="row">
            <div class="col-1" style="text-align: left">
              <input type="checkbox" id="lowercaseCheck" disabled />
            </div>
            <div class="col-10" style="text-align: left">
              <label for="">One Lowercase</label>
            </div>
          </div>

          <div class="row">
            <div class="col-1" style="text-align: left">
              <input type="checkbox" id="uppercaseCheck" disabled />
            </div>
            <div class="col-10" style="text-align: left">
              <label for="">One Uppercase</label>
            </div>
          </div>

          <div class="row">
            <div class="col-1" style="text-align: left">
              <input type="checkbox" id="numberCheck" disabled />
            </div>
            <div class="col-10" style="text-align: left">
              <label for="">One Number</label>
            </div>
          </div>

          <div class="row">
            <div class="col-1" style="text-align: left">
              <input type="checkbox" id="specialCharCheck" disabled />
            </div>
            <div class="col-10" style="text-align: left">
              <label for="">One Special Character</label>
            </div>
          </div>

          <div class="row">
            <div class="col-1" style="text-align: left">
              <input type="checkbox" id="minLengthCheck" disabled />
            </div>
            <div class="col-10" style="text-align: left">
              <label for="">Minimum 7 Characters</label>
            </div>
          </div>

          <!-- <div class="row">
          <div class="col-1" style="text-align: left">
            <input type="checkbox" id="sequentialNumbersCheck" disabled />
          </div>
          <div class="col-10" style="text-align: left">
            <label for="">No Sequential Numbers (e.g., 1234)</label>
          </div>
        </div>
        
        <div class="row">
          <div class="col-1" style="text-align: left">
            <input type="checkbox" id="usernameCheck" disabled />
          </div>
          <div class="col-10" style="text-align: left">
            <label for="">No Username in Password</label>
          </div>
        </div>
        
        <div class="row">
          <div class="col-1" style="text-align: left">
            <input type="checkbox" id="repeatingCharsCheck" disabled />
          </div>
          <div class="col-10" style="text-align: left">
            <label for="">No Repeating Characters (e.g., aaa)</label>
          </div>
        </div>
        
        <div class="row">
          <div class="col-1" style="text-align: left">
            <input type="checkbox" id="commonPasswordCheck" disabled />
          </div>
          <div class="col-10" style="text-align: left">
            <label for="">Not a Common Password (e.g., Password)</label>
          </div>
        </div> -->

        </div>
      </div>
    </div>

    <div style="min-height: 50px"></div>
    <div class="row">
      <div class="col-sm-2" style="text-align: right">
        <!-- <button type="submit" class="btn btn-primary mt-3">Submit</button> -->
      </div>
      <!-- <button type="submit" class="btn btn-primary">Create</button> -->

      <div class="col-sm-2" style="text-align: left">
        <button type="submit" class="btn custom-buttons-btn">Create</button>
      </div>
    </div>
  </form>
</div>